"use client"

import React, {useEffect} from "react";
import {useQuizHandler} from "./ContentItem/useQuizHandler";
import LocalizedLinkClient from "components/LocalizedLink/LocalizedLinkClient";
export const QuizItem = ({data, isReleaseNote, isStoring, isCursusItem}) => {

    useQuizHandler(data);

    useEffect(() => {
        if (!data) return
        window.scrollTo(0, 0);
    }, [data])


    return  <>
        <section>
            {/*header*/}
            <h1>{data.content_gepubliceerd.titel.replace(/(<.*>)/ig, '')}</h1>

            {/*Intro*/}
            <section className={`my-4 font-bold`}>
                {!isReleaseNote && data.content_gepubliceerd?.intro?.length > 0 &&
                    <div dangerouslySetInnerHTML={{__html: data.content_gepubliceerd.intro}}/>}
            </section>

            {isStoring && <div
                className={`my-3`}>{tekst('pagina:support:storingen:storing:laatste update')} {formatAanmaakDatum}</div>}

            <div dangerouslySetInnerHTML={{__html: data.content_gepubliceerd.bericht}}/>
        </section>


        {/*Tags*/}
        {!isCursusItem && <section>
            <div className={`flex-wrap gap-1`}>
                {data?.tag_groups_in_taal?.map(taggroep => {
                    return taggroep?.tags?.map(tag => {
                        return <LocalizedLinkClient key={tag.id} href={`/mijn-mkg/support/kenniscentrum?taggroep=${tag.id}`}
                                     className={`bg-cyan-light text-white font-bold hover:no-underline rounded-sm text-xs px-1`}
                                     style={{textDecoration: 'none', marginRight: '3px'}}>
                            <small className={`no-underline`}>{tag.naam}</small>
                        </LocalizedLinkClient>
                    })
                })}
            </div>
        </section>}
    </>

}